import { IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

import { useNavigate } from "react-router-dom"

const CloseButton = (props) => {
  const { callback, redirect_to } = props

  const navigate = useNavigate()

  const handleGoBack = () => {
    if (typeof callback === "function") callback()
    navigate(redirect_to || "/")
  }

  return (
    <IconButton
      aria-label="close"
      size="small"
      onClick={handleGoBack}
      sx={{ background: "#E8ECF4", borderRadius: "4px", ml: 3, width: 32, height: 32 }}
    >
      <CloseIcon fontWeight={700} sx={{ color: "primary.main" }} />
    </IconButton>
  )
}

export default CloseButton
